import React, { Component } from 'react';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { metaDescription } from 'utils/seoUtils';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";
import NapsTable from "./NapsTable";
import PropTypes from "prop-types";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";

@catchLifeCycleErrors
export default class NapsTablePage extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  render() {
    const helmetProps = {
      title: "Naps Table & Tips",
      ...metaDescription(`Today's naps table and records of the best horse racing tipsters in the UK and Ireland, including Sporting Life's Ben Linfoot.`)
    };

    const { location } = this.props;

    return (
      <StandardPage sport="racing" title="Naps Table & Tips" helmetProps={helmetProps} >
        <div className="main-layout-left-column">
          <div className="main-layout-block last-desktop">
            <NapsTable location={location} />
          </div>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/NapsTablePage.js